import { MobileDrawer } from '@Components/index';
import { Flex } from 'antd';
import { TenderTotalAmountResponse } from '@Types/api/form/tenderRequest/TenderTotalAmountResponse';
import { List } from '../../../common/List';

import styles from './price-breakdown.module.css';

interface UnlockPricingMobileProps {
  total: TenderTotalAmountResponse;
  isOpen: boolean;
  onCancel: () => void;
}

const PriceBreakdownMobile: React.FC<UnlockPricingMobileProps> = ({
  total,
  isOpen,
  onCancel,
}) => {
  return (
    <MobileDrawer open={isOpen} title="Price breakdown" onClose={onCancel}>
      <Flex vertical gap="16px" className={styles.priceBreakdownMobile}>
        <List>
          <List.Item
            title="Total Amount (Without Tax)"
            value={String(total.totalAmountWithoutTax)}
          />
          <List.Item title="Tax" value={String(total.totalTax || 0)} />
          <List.Item
            title="Total Amount (With Tax)"
            value={String(total.totalAmountWithTax || 0)}
          />
          <List.Item
            title="Final Amount"
            value={String(total.finalTotAmount || 0)}
            strong
          />
        </List>
      </Flex>
    </MobileDrawer>
  );
};

export default PriceBreakdownMobile;
